export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
export const API_BASE_URL_ELMSS = process.env.NEXT_PUBLIC_API_BASE_URL_ELMSS;
export const UPLOAD_BASE_URL = process.env.NEXT_PUBLIC_UPLOAD_BASE_URL;
export const DOWNLOAD_BASE_URL =
  process.env.NEXT_PUBLIC_DOWNLOAD_BASE_URL || 'https://api-lms-dev.tesse.io';
export const DOMAIN_HOST = process.env.NEXT_PUBLIC_DOMAIN_HOST;
export const ENABLED_DETECT_PERMISSION =
  process.env.ENABLED_DETECT_PERMISSION || true;
export const SOCKET_URL = process.env.NEXT_PUBLIC_SOCKET_URL;
export const YOUTUBE_SORT_LINK = 'https://www.youtube.com/watch?v=';
export const YOUTUBE_SORT_EMBED = 'https://www.youtube.com/embed/';
export const CURRENCY = process.env.NEXT_PUBLIC_CURRENCY || 'SGD';
export const LEARNER_ROLE_ID = process.env.NEXT_PUBLIC_LEARNER_ROLE_ID;
export const ELMSS_USERNAME = process.env.NEXT_PUBLIC_ELMSS_USERNAME;
export const ELMSS_PASSWORD = "&#$vfr$15"

/**
 * @type {"INFO" | "ERROR" | "DEBUG"}
 */
export const LOGGER_LEVEL = process.env.NEXT_PUBLIC_LOGGER_LEVEL || 'INFO';
